/**
 * Hidden weapons (อาวุธลับ): the move each one looses from the อาวุธลับ slot (data/gear.ts `throwSkill`), thrown
 * with `throwHidden` (systems/items.ts). Ordinary moves in every other way: their own cooldown, a little กำลังภายใน, the
 * existing `needles` projectile FX, the player's damage. They belong to no art, so no skill level raises them.
 */
import type { SkillDef } from './skills';

export const HIDDEN_SKILLS: readonly SkillDef[] = [
  {
    id: 'hidden-darts',
    name: 'ซัดลูกดอก',
    glyph: '鏢',
    kind: 'attack',
    qi: 4,
    cooldown: 5,
    windup: 0,
    range: 7,
    power: 0.45,
    volley: 2,
    fx: 'needles',
    desc: 'ซัดลูกดอกเหล็กสองดอกจากถุงข้างเอวใส่ศัตรูในระยะ 7 เมตร',
  },
  {
    id: 'hidden-needles',
    name: 'ซัดเข็มดอกเหมย',
    glyph: '針',
    kind: 'attack',
    qi: 6,
    cooldown: 6,
    windup: 0,
    range: 8,
    power: 0.4,
    volley: 4,
    fx: 'needles',
    desc: 'สะบัดแขนเสื้อ เข็มเงินสี่เล่มพุ่งใส่ศัตรูในระยะ 8 เมตร',
  },
];
